import styled from 'styled-components'

import { breakpoints } from '../../styles/global'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  padding-bottom: 100px;
  gap: 1.25em;
  row-gap: 1.25em;

  @media (min-width: ${breakpoints.min.tablet}px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));  
  }

  @media (min-width: ${breakpoints.min.laptop}px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`
